import React from 'react'

export function ModalContent({
  children,
}: {
  readonly children: React.ReactNode
}) {
  return <div className={'px-10 pt-10 max-w-[420px]'}>{children}</div>
}
